import { render } from "./AttributesPage.vue?vue&type=template&id=077ef3b9&ts=true"
import script from "./AttributesPage.vue?vue&type=script&lang=ts"
export * from "./AttributesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__